export const UPDATE_PROCESS_STATEMENTS_FAILURE = 'UPDATE_PROCESS_STATEMENTS_FAILURE';

export const updateProcessStatementsFailure = error => ({
    type: UPDATE_PROCESS_STATEMENTS_FAILURE,
    payload: error,
    error: true,
});
